import React from 'react'

const ThowColumLayoutLogin = ({ colum1, colum2, background }) => {
  return (
    <div
      className="login-layout"
      style={{ background: background || '#fff' }}
    >
      <div className="login-col1">{colum1}</div>
      <div className="login-col2">{colum2}</div>
    </div>
  )
}

export default ThowColumLayoutLogin
